import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createRecipesApi(client) {
    async function list(query) {
        return unwrap(await client.GET('/v1/recipes', { params: { query: query ?? {} } }));
    }
    return {
        list,
        iterate(query) {
            return paginate(list, query);
        },
        async get(id) {
            return unwrap(await client.GET('/v1/recipes/{id}', { params: { path: { id } } }));
        },
        async create(body) {
            return unwrap(await client.POST('/v1/recipes', { body }));
        },
        async replace(id, body) {
            return unwrap(await client.PUT('/v1/recipes/{id}', { params: { path: { id } }, body }));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/recipes/{id}', { params: { path: { id } } }));
        },
        async fork(id) {
            return unwrap(await client.POST('/v1/recipes/{id}/fork', { params: { path: { id } } }));
        },
    };
}
//# sourceMappingURL=recipes.js.map